<template>
        <span
            class="flex items-center justify-center relative z-10 overflow-hidden rounded-full shadow-sm focus:outline-none font-semibold"
            :class="[color, sizeClass]"
        >
            {{ user.initials }}
        </span>
</template>

<script>

export default {
    props: {
        user: {
            type: Object,
            default() {
                return {}
            }
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['md', 'lg'].includes(value),
        },
    },
    computed: {
        color() {
            if (this.user && this.user.color) {
                return `bg-${this.user.color} text-white`;
            }

            return '';
        },
        sizeClass() {
            return this.size === 'lg' ? 'h-16 w-16 text-lg' : 'h-12 w-12';
        },
    }
};
</script>
